import { css } from 'styled-components';

export default css`
  --brand-green: #2bd283;
  --brand-green-dark: #219f62;
  --brand-green-2: #7bcf89;
  --brand-blue: #0078ff;
  --brand-light-blue: var(--brand-blue);

  --red: #ff4f4f;
  --dark-red: #66292a;
  --red-background: #ff59591a;
  --orange-red: #ff2828;
  --orange-red-2: #ff002a;
  --light-red: #ffc5c6;
  --black: #202020;

  --light-gray: var(--bg-color-white-gray);
  --light-grey: var(--light-gray);
  --dark-gray: #494a4a;
  --dark-grey: var(--dark-gray);
  --gray: #666666;
  --grey: var(--gray);
  --icon-gray: #686868;

  --input-bg-mod: var(--bg-color-white-gray);

  --blue: var(--brand-blue);
  --blue-secondary: #3494ff;
  --blue-darker: #0459b9;

  --green: var(--brand-green);
  --green-secondary: #44c88a;
  --green-plus: #008207;

  --yellow: #ffb400;
  --yellow-secondary: #fdbe00;
  --yellow-bright: #ffd800;
  --yellow-background: #ffb4001a;
  --purple: #9524ff;

  --white: #fff;
  --white-box-background: #fff;
  --dark-box-background: #fff;
  --dark-box-border: #cccccc;
  --main-menu-background: #fff;
  --box-background: #fff;

  --error-color: var(--red);

  --text-color-blue: var(--brand-blue);
  --text-color-light-blue: var(--brand-light-blue);

  --text-color-white: #ffffff;
  --text-grey: #adadad;
  --text-white-gray: #ffffff;
  --text-black-grey: #000000;
  --text-color-white-gray: #b5b5b5;
  --text-color-light-gray: #6e6e6e;
  --text-color-medium-gray: #858585;
  --text-color-dark-gray: #444444;
  --text-color-black: #333333;
  --text-color: var(--text-color-black);
  --text-color-text-editor-active: #656566;
  --text-color-text-editor-notactive: #c3c4c4;

  --bg-color-text-input: #ffffff;
  --bg-color-grey-button: #3a3b3c;
  --bg-color-white-gray: #f3f5f4;
  --bg-color-white-dark-gray: #f3f5f4;
  --bg-color-light-gray: #e9e9e9;
  --bg-color-light-secondary-gray: #ebebeb;
  --bg-color-main-block: #ffffff;
  --bg-color-disabled: hsla(0, 0%, 100%, 0.6);
  --bg-color-capsule: #e9e9e9;
  --bg-hover-capsule: #c9c9c9;
  --bg-switch: #d0d0d0;
  --bg-input-color-editor: #ffffff;
  --bg-color-media-asset: #e9e9e9;

  --border-color: #bdbdbd;
  --border-color-grey: rgba(173, 173, 173, 0.5);
  --bg-text-editor-color: #ffffff;
  --bg-media-button: #d1d1d1;
  --bg-indicator: var(--border-color);

  --container-width: 1240px;
  --white-white: #ffffff;
  --white-black: #000000;
  --black-white: #ffffff;
  --black-white-transparent: rgba(255, 255, 255, 0.9);

  --color-danger: #ff5959;

  /* Fonts */
  --google-font: 'Google Sans', sans-serif;
  --noto-font: 'Noto Sans', sans-serif;
  --lato-font: 'Lato', sans-serif;
  --gilroy-font: 'Gilroy Extra', sans-serif;
  --google-sora: 'Google Sora', sans-serif;
  --google-sora-cdn: 'Sora', sans-serif;
  --base-font: var(--google-sora-cdn);

  /* Layout info */
  --menu-height: 110px;

  /* Transitions */
  --ease-out-cubic: cubic-bezier(0.22, 0.61, 0.36, 1);

  /* Shared attributes */
  --block-shadow: 0 8px 9px 0 rgba(0, 0, 0, 0.05);
  --block-shadow-alt: 0 8px 9px 0 rgba(0, 0, 0, 0.01);
  --block-border-radius: 10px;
  --block-spacing: 10px;

  /* TODO: NEW VARIABLES */
  --primary-1: hsl(152, 66%, 50%);
  --primary-1-light: hsl(212, 100%, 84%);
  --primary-2: hsl(212, 100%, 50%);

  --rgb-gradient: linear-gradient(to right, #037cfa, #c325d1, #ffb930, #ff6767);
  --hover-transition: 0.25s cubic-bezier(0.22, 0.61, 0.36, 1);
`;
